export function getReworkReference(search, storedReference) {
  const value = new URLSearchParams(search).get("refid") ?? storedReference;
  const reference = String(value ?? "").trim();
  return ["null", "undefined"].includes(reference) ? "" : reference;
}

export function getReworkVendor(response, reference) {
  if (!reference) throw new Error("No vendor reference was supplied. Open rework from the vendor list or your rework link.");
  const vendor = response.status && Array.isArray(response.data)
    ? response.data.find(item => String(item.reference_id) === String(reference))
    : null;
  if (!vendor) throw new Error("Could not load the selected vendor. Please reopen rework from the vendor list or your rework link.");
  if (vendor.approval_status !== "rework") throw new Error("This vendor is no longer awaiting rework.");
  return vendor;
}

export function populateReworkFields(fields, vendor) {
  return Object.fromEntries(Object.entries(fields).map(([key, field]) => [
    key, { ...field, value: vendor[key] ?? "", error: false }
  ]));
}

export function getDocumentUrl(path, baseUrl) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (!baseUrl) throw new Error("The document URL is not configured.");
  return baseUrl.replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
}

export async function prepareReworkUploads(fields, savedFields, baseUrl, fetchDocument = fetch) {
  const result = { ...fields };
  const mimeTypes = { pdf: "application/pdf", png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg" };
  for (const key of Object.keys(fields)) {
    if (key === "reference_id" || key === "declaration") continue;
    const selectedFile = fields[key].value;
    if (selectedFile) {
      if (!(selectedFile instanceof File) || ![...Object.values(mimeTypes), "image/jpg"].includes(selectedFile.type)) {
        throw new Error("Only PDF or images (JPG, JPEG, PNG) are allowed.");
      }
      continue;
    }
    const savedPath = savedFields[key]?.value;
    if (!savedPath) continue;
    const url = getDocumentUrl(savedPath, baseUrl);
    const filename = new URL(url).pathname.split("/").pop();
    const mimeType = mimeTypes[filename.split(".").pop().toLowerCase()];
    if (!mimeType) throw new Error("Please replace the unsupported document: " + filename);
    const response = await fetchDocument(url);
    if (!response.ok) throw new Error("Could not load " + filename + ". Please retry or upload a replacement.");
    const blob = await response.blob();
    if (blob.type.includes("text/html") || blob.type.includes("application/json")) {
      throw new Error("Could not load " + filename + ". Please retry or upload a replacement.");
    }
    result[key] = { ...fields[key], value: new File([blob], filename, { type: mimeType }) };
  }
  return result;
}
